export default "__VITE_ASSET__Be6W2j1u__"